import React from 'react';
import Header from "../Header/Header";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import {
    RouterProvider,
} from "react-router-dom";

import styles from './App.module.scss';
import Footer from "../Footer/Footer";
import AppStateProvider from "../../providers/app-state.provider";
import UserStateProvider from "../../providers/user-state.provider.ts";
import SubscriptionStatusProvider from "../../providers/subscription-status.provider";
import PurchaseStatusProvider from "../../providers/purchase-status.provider";
import PurchaseReminderProvider from "../../providers/purchase-reminder.provider";
import SavedStatusProvider from "../../providers/saved-status.provider";
import WatchStateProvider from "../../providers/watch-state.provider";
import router from "../../providers/router";
import { BASE_URL } from '../../types/constants';
import { CookiesProvider } from 'react-cookie';
import AuthModalProvider from "../../providers/auth-modal.provider";
import Login from "../Pages/Login/Login";
import MarketingTags from "../Marketing/MarketingTags";
import { useSubscriptionMarket } from '../../hooks/useSubscriptionMarket';

const SubscriptionMarketBootstrap = () => {
    const requestedMarketCode = typeof window === 'undefined'
        ? null
        : new URLSearchParams(window.location.search).get('market');
    useSubscriptionMarket(requestedMarketCode);
    return null;
};

function App() {
    if(BASE_URL === undefined) {
        console.error("BASE_URL is undefined");
    }
    if (process.env.REACT_APP_MAINTENANCE_MODE === 'true') {
        return (
          <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md w-full">
              <h1 className="text-3xl font-bold text-gray-800 mb-4">🚧 Maintenance Mode</h1>
              <p className="text-gray-600 mb-6">
                We're currently performing some maintenance. Please check back later. Thank you for your patience!
              </p>
              <div className="animate-pulse">
                <svg
                  className="w-12 h-12 mx-auto text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
            </div>
          </div>
        );
    }
    return (
    <div className={styles['app']}>
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <AppStateProvider>
            <UserStateProvider>
                <SubscriptionStatusProvider>
                    <PurchaseStatusProvider>
                        <SavedStatusProvider>
                            <WatchStateProvider>
                            <PurchaseReminderProvider>
                                <AuthModalProvider>
                            <MarketingTags />
                            <SubscriptionMarketBootstrap />
                            <div className={styles['header']}>
                                <Header />
                            </div>
                            <div className={styles.content}>
                                <ToastContainer position="top-right" autoClose={2000} />
                                <RouterProvider router={router} />
                            </div>
                            <div className={styles['footer']}>
                                <Footer />
                            </div>
                            <Login />
                                </AuthModalProvider>
                            </PurchaseReminderProvider>
                            </WatchStateProvider>
                        </SavedStatusProvider>
                    </PurchaseStatusProvider>
                </SubscriptionStatusProvider>
            </UserStateProvider>
        </AppStateProvider>
        </CookiesProvider>
    </div>
    );
}

export default App;
